import PropTypes from 'prop-types'
import React, { Component } from 'react'
import browserHistory from 'helpers/history'
import { localize } from 'helpers/translator'

import styles from './back_button.scss'

class BackButton extends Component {

	render() {
		if (this.props.onClick) {
			return (
				<button onClick={this.props.onClick} className={styles.base}>
					<div>{localize(this.props.textKey)}</div>
				</button>
			)
		} else if (this.props.forcedBackUrl === null) {
			return (
				<button onClick={browserHistory.goBack} className={styles.base}>
					<div>{localize(this.props.textKey)}</div>
				</button>
			)
		} else {
			return (
				<a href={this.props.forcedBackUrl} className={styles.base}>
					<div>{localize(this.props.textKey)}</div>
				</a>
			)
		}
	}

}

BackButton.defaultProps = {
	forcedBackUrl: null,
	textKey: 'global_back',
}

BackButton.propTypes = {
	forcedBackUrl: PropTypes.string,
	textKey: PropTypes.string,
}

export default BackButton
